import * as React from 'react';
import { useState } from 'react';
import OptionTypeForm from "../../components/OptionTypes/OptionTypeForm/OptionTypeForm";
import Submenu from '../../components/Submenu/Submenu';
import AppMenus from '../../config/appMenus';
import AppRoutes from '../../config/appRoutes';
var OptionType = function () {
    var appMenus = new AppMenus();
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var submenu = null;
    if (isEdit) {
        submenu = React.createElement(Submenu, { menuItems: appMenus.subMenuItems[AppRoutes.editOptionType.key] });
    }
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 Option type"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                isEdit ? submenu : null,
                React.createElement("div", { className: "col-md-5 " + (isEdit ? '' : 'offset-md-4') },
                    React.createElement(OptionTypeForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        isEdit: setIsEdit }))))));
};
export default OptionType;



//////////////////
// WEBPACK FOOTER
// ./src/views/OptionTypes/OptionType.tsx
// module id = 374
// module chunks = 0